import {Pipe, PipeTransform} from '@angular/core';
import {FaLightModel, FaModel} from '../../types/types';

@Pipe({name: 'collectionLink'})
export class CollectionLinkPipe implements PipeTransform {
  transform(fa2: FaModel | FaLightModel): string {
    return `/collection/${fa2.path || fa2.contract}`;
  }
}
